<template>
    <div class="w-full">
        <div class="w-full md:w-1/2 mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    Antrian Total
                </h1>
            </div>
            <div
                v-if="antrianTotal"
                class="w-full flex flex-col justify-center items-center"
            >
            <AntrianTotalCard
                :antrianTotal="antrianTotal"
            />
            </div>
            <div v-else class="w-full h-20 flex items-center bg-red-600 p-2 rounded-lg text-white justify-center mt-2">
                        Data antrian total belum tersedia
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutNoHeader from "../Shared/LayoutNoHeader.vue";
import RandomShape from "../Shared/RandomShape.vue";
import AntrianTotalCard from "../Shared/AntrianTotalCard.vue";
export default {
    components: {
        Link,
        RandomShape,
        AntrianTotalCard
    },
    props: {
        antrianTotal: Object,
    },
    layout: LayoutNoHeader,
};
</script>
